import * as React from 'react'
import {LazyLoadErrorBoundary} from './lazy-load-error-boundary'

const {Suspense} = React

interface ILazyLoadComponentProps {
  fallback: React.ReactElement
  errorIndicator: React.ReactElement
}

export const LazyLoadComponentWrapper = (
  props: React.PropsWithChildren<ILazyLoadComponentProps>,
) => {
  return (
    <LazyLoadErrorBoundary errorIndicator={props.errorIndicator}>
      <Suspense fallback={props.fallback}>{props.children}</Suspense>
    </LazyLoadErrorBoundary>
  )
}
